import { render, staticRenderFns } from "./route-tabs.vue?vue&type=template&id=837a3f10"
import script from "./route-tabs.vue?vue&type=script&lang=ts"
export * from "./route-tabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports